import { render, staticRenderFns } from "./technical-demos-and-videos-program.vue?vue&type=template&id=7098155b&scoped=true&"
import script from "./technical-demos-and-videos-program.vue?vue&type=script&lang=js&"
export * from "./technical-demos-and-videos-program.vue?vue&type=script&lang=js&"
import style0 from "./technical-demos-and-videos-program.vue?vue&type=style&index=0&id=7098155b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7098155b",
  null
  
)

export default component.exports